/**
 * Created by User on 18/02/2016.
 */
export default Utils;

function Utils() {

}
Utils.isStringWithData = function(string) {
  return string && typeof string === 'string' && string.length > 0;
};

Utils.isURLisIMA = function(url) {
  //MHP-1503
  //Происходит ложный детект IMA если в гет параметрах есть .doubleclick
  //при этом нельзя явно хардкодить полный домен т.к это может быть pubads.doubleclick, ad.doubleclick и т.д
  //при этом нельзя делать сложных решений и player.config.getUrlParser ибо Smart TV

  if (!url) return false;
  var split = url.split('?');
  return split[0] ? split[0].indexOf('.doubleclick') !== -1 : false;
};

Utils.isURLisYandex = function(url) {
  return /^yandex:/.test(url);
};

Utils.needWeboramaDMP = function(adlist) {
  return adlist ? (adlist.indexOf('v.adfox.ru') !== -1 || adlist.indexOf('/226279/') !== -1) : false;
};

Utils.findDiD = function (url, player) {
	if (player.config.deviceID) return;
	var parts = url.split("&");
	for (var i = 0; i < parts.length; i++) {
		if (parts[i].indexOf("device_id") !== -1) {
			player.config.deviceID = parts[i].substr(parts[i].indexOf("=")).replace("=", "");
		}
	}
}
